import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {
  orderItemsById,
  orderTrackingNumberById,
  orderTrackingUrlById,
} from '/redux/selector/client.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';

import ShipmentSection from './ShipmentSection';

export default connect(
  createStructuredSelector({
    trackingNumber: orderTrackingNumberById,
    trackingUrl: orderTrackingUrlById,
    items: orderItemsById,
    featureFlag: variablesFeatureFlag,
  }),
)(ShipmentSection);
